import { FormService } from 'src/app/services/form.service';
import { DISCOUNTS } from 'src/app/app.constants';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { Component, inject, computed } from '@angular/core';

@Component({
    selector: 'app-discount-state',
    imports: [
        TranslatePipe,
        NgClass
    ],
    templateUrl: './discount-state.component.html',
    styleUrl: './discount-state.component.scss'
})
export class DiscountStateComponent {
  private formService = inject(FormService);

  readonly discounts = DISCOUNTS;

  private durationInDays = computed(() => this.formService.form().durationInDays || 0);

  isInRange(range: string): boolean {
    if (this.durationInDays() === 0) return false;
    if (range.includes('+')) {
      const min = parseInt(range);
      return this.durationInDays() >= min;
    }
    const [min, max] = range.split('-').map(Number);
    return this.durationInDays() >= min && this.durationInDays() <= max;
  }

}
